import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    if (!visible) return null;

    return (
        <motion.button
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.3 }}
            onClick={scrollToTop}
            className="rounded-circle position-fixed border-0"
            style={{
                bottom: "25px",
                right: "25px",
                width: "45px",
                height: "45px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                zIndex: 1050,
                backgroundColor: "#2f5aa2",
                color: "#fff"
            }}
        >
            <ArrowUp size={20} />
        </motion.button>
    );
}

export default ScrollToTopButton;